import { render, staticRenderFns } from "./OrgMemberModal.vue?vue&type=template&id=33513ae4&scoped=true"
import script from "./OrgMemberModal.vue?vue&type=script&lang=ts"
export * from "./OrgMemberModal.vue?vue&type=script&lang=ts"
import style0 from "./OrgMemberModal.vue?vue&type=style&index=0&id=33513ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33513ae4",
  null
  
)

export default component.exports